<template>
  <div>
    <q-layout>
      <!-- Router view for outside view -->
      <router-view />
    </q-layout>
  </div>
</template>

<script>
export default {
  name: 'layoutOutside',
};
</script>

<style lang="stylus">
@import '~variables';
    .q-layout
      background-color $ctrl-darkmatter-darken-3
</style>
